<ion-header *ngIf="showSearchField">
  <ion-searchbar
    (ionChange)="onSearchTermChange($event)"
    (keyup.enter)="onEnterPressed()"
    debounce="300"
    placeholder="{{ 'm/task-process/gifs/search' | translate }}"></ion-searchbar>
</ion-header>

<ion-content>
  <ion-list>
    <ng-container *ngFor="let common_user of displayedAssigneeList.common_users">
      <ng-container *ngTemplateOutlet="user; context: { user: common_user }"></ng-container>
    </ng-container>
    <div class="separator item"><div></div></div>
    <ng-container *ngFor="let company_user of displayedAssigneeList.company_users">
      <ng-container *ngTemplateOutlet="user; context: { user: company_user }"></ng-container>
    </ng-container>
  </ion-list>
  <ng-template #user let-user="user">
    <div class="item" (click)="ok(user.id)">{{ user.realname }}</div>
  </ng-template>
</ion-content>
